const MAX_LISTED_USERS = 8;
// Matches the server's per-list limit
const MAX_CARD_IDS = 500;

let outsideClickBound = false;

export function collectTradeCardIds(root) {
    const wanted = [];
    const trade = [];
    root.querySelectorAll('.card-row').forEach(row => {
        if (Number(row.dataset.bsWanted) > 0) {
            wanted.push(row.id);
        }
        if (Number(row.dataset.bsTrade) > 0) {
            trade.push(row.id);
        }
    });
    return { wanted, trade };
}

function userList(heading, users) {
    const section = document.createElement('div');
    section.className = 'card-traders-section';

    const title = document.createElement('div');
    title.className = 'fw-semibold small mb-1';
    title.textContent = heading;
    section.appendChild(title);

    const list = document.createElement('div');
    list.className = 'd-flex flex-wrap gap-1';
    users.slice(0, MAX_LISTED_USERS).forEach(user => {
        const link = document.createElement('a');
        link.className = 'badge badge-owner-username rounded-pill text-decoration-none';
        link.href = `/user/${encodeURIComponent(user.user_id)}`;
        link.textContent = user.username;
        list.appendChild(link);
    });
    if (users.length > MAX_LISTED_USERS) {
        const more = document.createElement('span');
        more.className = 'small text-muted';
        more.textContent = `+${users.length - MAX_LISTED_USERS} more`;
        list.appendChild(more);
    }
    section.appendChild(list);
    return section;
}

export function buildPopoverContent(traders) {
    const content = document.createElement('div');
    content.className = 'card-traders-popover d-flex flex-column gap-2';
    if (traders.have.length) {
        content.appendChild(userList('Have it for trade', traders.have));
    }
    if (traders.want.length) {
        content.appendChild(userList('Want it', traders.want));
    }
    const link = document.createElement('a');
    link.className = 'small';
    link.href = '/trades';
    link.textContent = 'See all trade partners';
    content.appendChild(link);
    return content;
}

export function buildTraderBadge(traders) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'card-row-traders';

    const parts = [];
    if (traders.have.length) {
        parts.push(`<span class="card-traders-have"><i class="bi bi-box-arrow-in-down" aria-hidden="true"></i> ${traders.have.length} ${traders.have.length === 1 ? 'has' : 'have'}</span>`);
    }
    if (traders.want.length) {
        parts.push(`<span class="card-traders-want"><i class="bi bi-box-arrow-up" aria-hidden="true"></i> ${traders.want.length} ${traders.want.length === 1 ? 'wants' : 'want'}</span>`);
    }
    button.innerHTML = parts.join('');
    button.setAttribute('aria-label',
        `${traders.have.length} traders have this card, ${traders.want.length} traders want it`);
    return button;
}

export function renderTraderBadges(root, cards) {
    const badges = [];
    Object.entries(cards).forEach(([cardId, traders]) => {
        const row = root.querySelector(`.card-row[id="${CSS.escape(cardId)}"]`);
        const nameEl = row ? row.querySelector('.card-row-name') : null;
        if (!nameEl || (!traders.have.length && !traders.want.length)) {
            return;
        }
        nameEl.querySelector('.card-row-traders')?.remove();
        const badge = buildTraderBadge(traders);
        badge.traders = traders;
        nameEl.appendChild(badge);
        badges.push(badge);
    });
    return badges;
}

function enablePopovers(badges) {
    if (!window.bootstrap) {
        return;
    }
    badges.forEach(badge => {
        new bootstrap.Popover(badge, {
            content: buildPopoverContent(badge.traders),
            html: true,
            trigger: 'click',
            placement: 'auto',
            customClass: 'help-popover'
        });
    });
    if (outsideClickBound) {
        return;
    }
    outsideClickBound = true;
    // Only one open at a time, and clicking elsewhere closes it
    document.addEventListener('click', event => {
        if (event.target.closest('.popover')) {
            return;
        }
        const clicked = event.target.closest('.card-row-traders');
        document.querySelectorAll('.card-row-traders').forEach(badge => {
            if (badge !== clicked) {
                bootstrap.Popover.getInstance(badge)?.hide();
            }
        });
    });
}

export async function loadCardTraders(root) {
    if (!root) {
        return;
    }
    const { wanted, trade } = collectTradeCardIds(root);
    if (!wanted.length && !trade.length) {
        return;
    }
    try {
        const response = await fetch('/api/current_user/card_traders', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ wanted: wanted.slice(0, MAX_CARD_IDS), trade: trade.slice(0, MAX_CARD_IDS) })
        });
        if (!response.ok) {
            return;
        }
        const data = await response.json();
        enablePopovers(renderTraderBadges(root, data.cards || {}));
    } catch (e) {
        // Trader badges are a nice-to-have; the card list works without them
    }
}
